// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import JobRequestService from 'services/JobRequestService';

// Components
import Loader from 'components/common/Loader';
import EditJobRequestModal from 'components/admin/job-request/EditJobRequestModal';
import PageHeader from 'components/common/PageHeader';

//-------------------------------------------------------------------------------------------------------------------

class JobRequestsPage extends React.Component {

    constructor(props) {
        super(props);

        this.editJobRequestModalRef = React.createRef();

        this.requestID = 1;
        this.state = {
            isLoadingFilters: true,
            isLoading: true,
            filters: {
                type: 'SwapSearch'
            }
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.loadFilters();
        GlobalStateService.setValues({ area: 'swap-search' });
    }

    async loadFilters() {
        const {
            filters
        } = this.state;

        const months = await JobRequestService.listMonths(filters.type);
        this.setState({
            months,
            isLoadingFilters: false
        }, () => {
            if (months.length > 0) {
                this.setState({
                    filters: {
                        ...filters,
                        month: months[0]
                    }
                }, () => {
                    this.load();
                });
            } else {
                this.setState({
                    isLoading: false,
                    jobRequests: []
                });
            }
        });
    }

    async load() {
        const {
            filters
        } = this.state;
        const jobRequests = await JobRequestService.list(filters);
        this.setState({
            jobRequests,
            isLoading: false
        });
    }

    async editJobRequest(jobRequest) {
        await this.editJobRequestModalRef.current.show({
            jobRequestID: jobRequest.id
        });
        this.loadFilters();
    }

    async addJobRequest() {
        await this.editJobRequestModalRef.current.show({
            type: this.state.filters.type
        });
        this.loadFilters();
    }

    updateFilter(name, value) {
        const filters = { ...this.state.filters };
        filters[name] = value;
        this.setState({
            filters
        }, () => {
            switch (name) {
                case 'type':
                    this.loadFilters();
                    break;
                case 'month':
                    this.load();
                    break;
            }
        });
    }

    render() {
        return (<>
            <div className="page job-requests-page">
                
                <PageHeader>
                    <h1>Swap Search</h1>

                    <div className="buttons">

                        <button className="btn btn-primary" onClick={e => this.addJobRequest()}>
                            <span className="fa-solid fa-plus" />{' '}
                            Add New
                        </button>

                    </div>
                </PageHeader>

                <main>

                    <Container>

                        <section className="filters">

                            {this.renderFilters()}

                        </section>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <EditJobRequestModal ref={this.editJobRequestModalRef} />

        </>);
    }

    renderFilters() {
        const {
            isLoadingFilters,
            filters,
            months
        } = this.state;

        if (isLoadingFilters) {
            return (<Loader />);
        }

        return (<>

            <Form.Group>
                <Form.Label>Type</Form.Label>
                <select
                    className="form-control"
                    value={filters.type || ''}
                    onChange={e => this.updateFilter('type', e.target.value)}
                >
                    <option value="">(All)</option>
                    <option value="JobRequest">Job Request</option>
                    <option value="SwapSearch">Swap Search</option>
                </select>
            </Form.Group>

            {months.length > 0 &&
                <Form.Group>
                    <Form.Label>Month</Form.Label>
                    <select
                        className="form-control"
                        value={filters.month || ''}
                        onChange={e => this.updateFilter('month', e.target.value)}
                    >
                        {months.map(month =>
                            <option key={moment(month).format('YYYY-MM')} value={moment(month).format('YYYY-MM-01')}>
                                {moment(month).format('MMM YYYY')}
                            </option>
                        )}
                    </select>
                </Form.Group>
            }

        </>);
    }
    
    renderInner() {
        const {
            isLoading,
            jobRequests,
            filters
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        let typeName;
        switch (filters.type) {
            case 'JobRequest': typeName = 'Job requests'; break;
            case 'SwapSearch': typeName = 'Swap searches'; break;
        }

        if (jobRequests.length == 0) {
            return (
                <div className="empty-text">
                    No {typeName} to show
                </div>
            );
        }

        return (
            <div className="sticky-table-container scrolling">

                <table className="table table-bordered sticky-table selectable">
                    <thead>
                        <tr>
                            <th>Course</th>
                            <th>Language</th>
                            <th>Date</th>
                            <th>Time Zone</th>
                            <th># Instructors</th>
                            {filters.type == 'JobRequest' &&
                                <th>Status</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {jobRequests.map(jr =>
                            <tr key={jr.id} onClick={e => this.editJobRequest(jr)}>
                                <td>{jr.course}</td>
                                <td>{jr.language}</td>
                                <td>
                                    {jr.startDate ? moment(jr.startDate).format('DD/MM/YYYY') : ''}
                                    {jr.numDays > 0 ? <><br />{jr.numDays} day{jr.numDays != 1 && 's'}</> : ''}
                                </td>
                                <td>{jr.timeZone}</td>
                                <td>{jr.numInstructors}</td>
                                {filters.type == 'JobRequest' &&
                                    <td>
                                        {jr.dateNotified ?
                                            <>Notified on {moment(jr.dateNotified).format('DD/MM/YYYY')}</> :
                                            <span className="text-bad">Not notified</span>
                                        }
                                    </td>
                                }
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }

}

export default withRouter(JobRequestsPage);